import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { FileManagerService } from '../../file-manager.service';

@Component({
  selector: 'app-file-manager-image',
  templateUrl: './file-manager-image.component.html',
  styleUrls: ['./file-manager-image.component.css']
})
export class FileManagerImageComponent implements OnInit {

  @Input() roundImage: boolean = false;
  @Input() roundCorners: boolean = false;
  @Input() maxHeight: number | null | undefined;
  @Input() maxWidth: number | null | undefined;
  @Input() height: number | null | undefined;
  @Input() width: number | null | undefined;
  @Input() documentID: string;

  // This is actually a pretty lazy way to do this
  @Input() fillParentWidth: boolean = false;
  @Input() resizable: boolean = false;

  show: boolean = true;
  sanitizedURL: any;;
  documentURL: string = "";
  isLoading: boolean = false;
  isImage: boolean = true;

  imageExtList: string[] = [
    'apng',
    'bmp',
    'gif',
    'gif',
    'ico',
    'cur',
    'jpg',
    'jpeg',
    'jfif',
    'pjpeg',
    'pjp',
    'png',
    'svg',
    'tif',
    'tiff',
    'webp',    
  ];

  nonImageExtList: string[] = [
    'pdf'
  ];

  constructor(
    private fileService: FileManagerService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.getDocumentURL(this.documentID)
      .then((response: string) => {
        this.documentURL = response;

        //console.log('CHECKING', this.documentURL);

        //this.nonImageExtList.forEach(ext => {
        //  if (this.documentURL.toLowerCase().indexOf(ext) > -1) {
        //    this.isImage = false;
        //  }
        //});



        console.log("sanitized", response)

        this.sanitizedURL = this.getSanitizedURL(response);
        console.log("sanitized", this.sanitizedURL)
        this.isLoading = false;
      }, err => {
        this.isLoading = false;
      });
  }

  getDocumentURL(documentID: string) {
    let promise = new Promise((resolve, reject) => {
      this.fileService.getDocumentURLPromise(this.documentID)
        .then(resolve, reject);
    });
    return promise;
  }

  getSanitizedURL(url: string) {
    var tmp = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    return tmp;
  }

  markDocumentAsDeleted() {
    console.log("FileManagerImageComponent markDocumentAsDeleted");
    this.fileService.markDocumentAsDeleted(this.documentID)
      .subscribe(response => {
      }, err => {
      });
  }

}
